const integrations = {
  title: "Integrations",
  description: "Integrate all your tools in one place",
  empty: {
    title: "No integrations found",
    description: "Configure a new integration to get started"
  },
  new: {
    title: "New Integration",
    description: "Configure a new integration"
  },
  form: {
    name: "Name",
    description: "Description",
    type: "Type",
    status: "Status",
    authType: "Authentication Type",
    selectAuthType: "Select an authentication type",
    title: {
      label: "Integration Name",
      placeholder: "Ex: Jira for Mobile Squad",
      required: "Integration name is required"
    },
    errors: {
      requiredFields: "Required fields not filled: {{fields}}",
      create: "Error creating integration. Check the data and try again.",
      update: "Error updating integration. Check the data and try again.",
      unknown: "Unknown error"
    },
    defaultDescription: "Integration configured via Prodgy"
  },
  status: {
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    failed: "Failed",
    connected: "Connected",
    disconnected: "Disconnected",
    syncing: "Syncing",
    synced: "Synced",
    unknown: "Unknown"
  },
  fields: {
    apiKey: "API Key",
    model: "Model",
    clientId: "Client ID",
    clientSecret: "Client Secret",
    accessToken: "Access Token",
    redirectUri: "Redirect URI",
    privateToken: "Private Token",
    gitlabUrl: "GitLab URL",
    gitlabProjectId: "GitLab Project ID",
    organization: "Organization",
    googleProjectId: "Google Project ID",
    username: "Username",
    password: "Password",
    scope: "Scope",
    apiKeyPlaceholder: "Enter your OpenRouter API key",
    modelPlaceholder: "Enter model name (e.g. openai/gpt-4)",
    clientIdPlaceholder: "Enter Client ID",
    clientSecretPlaceholder: "Enter Client Secret",
    accessTokenPlaceholder: "Enter Access Token",
    redirectUriPlaceholder: "Enter Redirect URI",
    privateTokenPlaceholder: "Enter Private Token",
    gitlabUrlPlaceholder: "Enter GitLab URL",
    gitlabProjectIdPlaceholder: "Enter GitLab Project ID",
    organizationPlaceholder: "Enter Organization name",
    googleProjectIdPlaceholder: "Enter Google Project ID",
    usernamePlaceholder: "Enter username",
    passwordPlaceholder: "Enter password",
    scopePlaceholder: "Enter scope"
  },
  actions: {
    connect: "Connect",
    disconnect: "Disconnect",
    save: "Save changes",
    cancel: "Cancel",
    test: "Test connection",
    sync: "Sync",
    update: "Update",
    connecting: "Connecting...",
    updating: "Updating...",
    remove: "Remove",
    configure: "Configure"
  },
  messages: {
    connected: "Integration connected successfully",
    disconnected: "Integration disconnected successfully",
    saved: "Changes saved successfully",
    error: "Error processing operation",
    authUpdated: "Authentication settings updated successfully",
    authUpdateError: "Failed to update authentication settings",
    connectionTestFailed: "Connection test failed. Please check your credentials and try again.",
    cannotDelete: "Cannot remove integration",
    deleteSuccess: "was removed successfully!",
    deleteError: "Error removing integration. Please try again.",
    hasDependencies: "This integration is being used by {{dependencies}}. Remove these dependencies before deleting the integration."
  },
  searchPlaceholder: "Search integrations...",
  searchTools: "Search tools...",
  addIntegration: "Add Integration",
  add: "Add",
  encrypted: "Encrypted",
  configure: "Configure",
  lastValidated: "Last validated",
  selectTemplate: "Select the tool you want to integrate with Prodgy",
  select: "Select",
  sections: {
    settings: "Settings",
    authentication: "Authentication"
  },
  placeholders: {
    select: "Select...",
    enterField: "Enter {{field}}"
  },
  defaultFields: {
    integrationName: "Integration Name",
    integrationNamePlaceholder: "Enter a name for this integration",
    apiKeyToken: "API Key/Token"
  },
  editDialog: {
    edit: "Edit",
    editTitle: "Edit {{name}}",
    updateSettings: "Update the integration settings and credentials",
    configureIntegration: "Configure the integration"
  },
  scope: {
    label: "Scope",
    addTo: "Add the integration to...",
    workspaceOnly: "Workspace only",
    globalAll: "Whole organization",
    sectionWorkspace: "From the workspace",
    sectionOrganization: "From the whole organization",
    missingOrg: "Could not identify the current organization.",
    missingWorkspace: "Select a workspace or mark the integration as global.",
    permissionsLabel: "Permissions",
    productLabel: "Product",
    organizationLabel: "Organization",
    organizationHint: "This integration will be available for use in all products of the organization.",
    productHint: "This integration will be restricted to the current product and will override the organization version, if it exists.",
    product: "This product",
    general: "Global"
  },
  postInstall: {
    title: "Integration created — next steps",
    subtitle: "Configure {{name}} using the values below and follow the instructions to complete installation.",
    copied: "URL copied",
    copyFailed: "Failed to copy",
    copy: "Copy",
    instructionsLabel: "Setup instructions",
    confirm: "Got it",
    manifestLabel: "App Manifest",
    copyManifest: "Copy JSON",
    downloadZip: "Download ZIP",
    zipBuilding: "Building...",
    zipFailed: "Failed to build the ZIP package"
  },
  delete: {
    title: "Remove Integration",
    confirmMessage: "Are you sure you want to remove the integration <strong>{{name}}</strong>?",
    warning: "This action cannot be undone. All settings and credentials will be permanently lost.",
    removing: "Removing...",
    confirm: "Yes, Remove"
  },
  selector: {
    noIntegrations: "No integrations",
    noToolsFound: "No tools found",
    resultCount_one: "{{count}} integration",
    resultCount_other: "{{count}} integrations",
    filtered_one: "filtered",
    filtered_other: "filtered",
    forQuery: "for \"{{query}}\"",
    requiredNotInstalled: "The integration required by the agent is not installed",
    addNewPrompt: "Or add a new integration...",
    addFirstPrompt: "Add an integration to get started...",
    templateDescription: "Integration template"
  }
} as const;

export default integrations;
